// @flow
import type { CallPartner } from '../types/callPartner'

export const SET_CALLPARTNER = 'callPartner/set_callPartner'

type State = {
  listCallPartner: Array<CallPartner>,
}

type Action = {
  type: string,
  payload: any,
}

const initialState: State = {
  listCallPartner: [],
}

export default (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case SET_CALLPARTNER:
      return {
        ...state,
        listCallPartner: action.payload,
      }
    default:
      return state
  }
}
